import { FixedPageHeader } from 'Components/Layout';
import { useSelector } from 'react-redux';

const FixedStandardisationHeader: React.FC = () => {
  const syncing = useSelector((state) => state.gaugeStandardisation.status.synchronising);
  const dirty = useSelector((state) => state.gaugeStandardisation.status.dirty);

  return (
    <FixedPageHeader
      pageIdentifier="Nuclear Gauge Standardization"
      pageStatus={syncing ? 'Saving...' : 'Saved'}
      pageProcessing={syncing || dirty}
    />
  );
};

export default FixedStandardisationHeader;
